/**
 * Notification Sound Utility
 * 
 * Handles playing notification sounds when new notifications are received
 */

let audioInstance: HTMLAudioElement | null = null;

/**
 * Play the notification sound
 * @param volume - Volume level (0.0 to 1.0), defaults to 0.5
 */
export const playNotificationSound = (volume: number = 0.5): void => {
  try {
    // Create or reuse audio instance
    if (!audioInstance) {
      audioInstance = new Audio('/assets/notification-sound.wav');
      audioInstance.volume = volume;
      // Reset audio to beginning if it's already been played
      audioInstance.addEventListener('ended', () => {
        audioInstance?.load(); // Reset to beginning
      });
    }

    // Set volume
    audioInstance.volume = volume;

    // Play the sound
    audioInstance.play().catch((error) => {
      console.warn('Could not play notification sound:', error);
      // Some browsers require user interaction before playing audio
      // This is expected behavior and not a critical error
    });
  } catch (error) {
    console.warn('Error playing notification sound:', error);
  }
};

/**
 * Preload the notification sound for better performance
 */
export const preloadNotificationSound = (): void => {
  try {
    if (!audioInstance) {
      audioInstance = new Audio('/assets/notification-sound.wav');
      audioInstance.volume = 0.5;
      audioInstance.preload = 'auto';
    }
  } catch (error) {
    console.warn('Error preloading notification sound:', error);
  }
};
